import z from 'zod';

import {
  AwardCountSchema,
  GameConfigurationSchema,
  NativeGamePaletteVariantSchema,
  SegmentSchema,
  SpinWheelGameConfigSchema,
} from './validation';

export enum GameType {
  SPIN_THE_WHEEL = 'SPIN_THE_WHEEL',
}

export enum SegmentIcon {
  PRIZE = 'prize',
  PUMP = 'pump',
  FOOD = 'food',
  DRINK = 'drink',
}

export type SegmentFormValues = z.infer<typeof SegmentSchema>;
export type SpinWheelGameOfferFormValues = z.infer<typeof SpinWheelGameConfigSchema>;
export type GameOfferLimitsInConstraintGroupFormValue = z.infer<typeof AwardCountSchema>;
export type GameConfigureFormValues = z.infer<typeof GameConfigurationSchema>;

export type SpinWheelGameOfferCustomData = SpinWheelGameOfferFormValues & {
  segments: { icon: SegmentIcon | null; color: string | null }[];
};

export type GameOfferCustomData = {
  version: 1;
  spinWheelGame: SpinWheelGameOfferCustomData | null;
};

export type NativeGamePaletteVariant = z.infer<typeof NativeGamePaletteVariantSchema>;
